/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native'


export default StyleSheet.create({
    container: {
        padding: 20,
      },
    
      title: {
        color: 'black',
 
        fontSize: 15,
      },
    
      textInput: {
        color: 'black',
        textAlignVertical : "top",
        fontSize: 15,
        flex: 1,
        lineHeight: 25,
        height: 105,
      }
  })


